var base = require('./base.js')

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?)/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

function getUploadToken(usage, successCallback, failCallback) {
  console.log(base)
  console.log(base.verifiedRequest)
  base.default.verifiedRequest({
    path: '/api/portal/v1/upload/token/',
    method: 'POST',
    data: { usage: usage },
    success: function (res) {
      successCallback && successCallback(res)
    },
    fail: function (msg) {
      failCallback && failCallback(msg)
    }
  })
}

function singleUpload(tmpPath, usage, successCallback, failCallback) {
  if (tmpPath.indexOf('http') === 0) {
    successCallback && successCallback(tmpPath)
    return
  }
  getUploadToken(usage, function (tokenRes) {
    var token = tokenRes['token']
    var key = tokenRes['key']
    var url = tokenRes['url']

    var formData = new FormData()
    formData.append('token', token)
    formData.append('key', key)
    formData.append('file', dataURLtoBlob(tmpPath))
    var request = new XMLHttpRequest()
    request.open('POST', 'https://upload.qiniup.com/')
    request.onload = function (e) {
      if (request.readyState === 4) {
        if (request.status === 200) {
          successCallback && successCallback(url)
        } else {
          failCallback && failCallback(e)
        }
      }
    }
    request.send(formData)
  }, function (errorMsg) {
    failCallback && failCallback(errorMsg)
  })
}

function batchUpload(tmpPaths, usage, successCallback, failCallback) {
  if (tmpPaths.length === 0) {
    successCallback([])
    return
  }
  var taskIndex = 0
  var urls = []
  function doTask() {
    singleUpload(tmpPaths[taskIndex], usage, function (url) {
      urls.push(url)
      taskIndex += 1
      if (taskIndex >= tmpPaths.length) {
        successCallback(urls)
      } else {
        doTask()
      }
    }, function (msg) {
      failCallback(msg)
    })
  }
  doTask()
}

export default {
  getUploadToken: getUploadToken,
  singleUpload: singleUpload,
  batchUpload: batchUpload
}



// WEBPACK FOOTER //
// ./src/service/upload.js